const _ = require("lodash");

module.exports = class EmailBlocker {
	isBlocked (email, windowProperty, check) {
		const rawList = JSON.parse(window.atob(
			_.get(
				window,
				windowProperty,
				window.btoa('""')
			)
		)).replaceAll(/\s/g, "");

		const blockList = _.split(
			rawList,
			","
		);

		return  _.some(
			blockList,
			domain => !_.isEmpty(domain) && check(email, domain)
		);
	}

	isBlockedEmailDomain (email) {
		return this.isBlocked(
			email,
			"ITBL.blocked_email_domains",
			_.endsWith
		);
	}

	isSilentlyBlockedEmailDomain (email) {
		return this.isBlocked(
			email,
			"ITBL.silent_blocked_email_domains",
			_.endsWith
		);
	}

	isBlockedEmailString (email) {
		return this.isBlocked(
			email,
			"ITBL.blocked_email_strings",
			_.includes
		);
	}

	isValidDropOffEmail (email) {
		return (
			!this.isBlockedEmailDomain(email) &&
			!this.isBlockedEmailString(email) &&
			!this.isSilentlyBlockedEmailDomain(email)
		);
	}
}